import { useQuery } from "@tanstack/react-query";
export const useServerTime = () => {
    return useQuery(["time"], async () => {
        return await fetch(window.__APP_CONFIG.apiUrls.time).then((res) => res.json());
    }, {
        staleTime: 1000 * 60,
        cacheTime: 1000 * 60,
    });
};
//# sourceMappingURL=useTime.js.map